module.exports = __webpack_public_path__ + "685e405dbba7ce2185d72c948ad3b100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/14_prop_16.png
// module id = 115
// module chunks = 0